import { useEffect, useState, type ComponentType } from 'react';
import { t } from '../messages';
import { AppErrorBoundary } from '../host/AppErrorBoundary';

let loaded: ComponentType | undefined;
/** Ne charge les écrans professeur qu’à leur ouverture ; une réduction conserve leur état. */
export function TeacherSpaceMount() {
  const [Screen, setScreen] = useState<ComponentType | undefined>(() => loaded);
  const [failed, setFailed] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    const loading = loaded ? Promise.resolve({ TeacherSpace: loaded }) : import('./TeacherSpace');
    void loading
      .then((module) => {
        loaded = module.TeacherSpace;
        if (active) setScreen(() => module.TeacherSpace);
      })
      .catch(() => {
        if (active) setFailed(true);
      });
    return () => {
      active = false;
    };
  }, [attempt]);
  if (Screen)
    return (
      <AppErrorBoundary resetKey="teacher">
        <Screen />
      </AppErrorBoundary>
    );
  if (failed)
    return (
      <section role="alert">
        <p>{t('teacher.loadFailed')}</p>
        <button
          type="button"
          className="ndrc-button"
          onClick={() => {
            setFailed(false);
            setAttempt((value) => value + 1);
          }}
        >
          {t('teacher.loadRetry')}
        </button>
      </section>
    );
  return <p role="status">{t('teacher.loading')}</p>;
}
